module.exports = __webpack_public_path__ + "static/media/chevron-down.c9014a78.svg";